<template>
    <transition name="fade">
        <div
            v-if="localErrors.length"
            class="rounded-md text-left flex items-start gap-2 p-1 text-red-500 relative"
        >
            <Icon icon="caution" svgClass="w-8 h-8" />
            <ul>
                <li
                    class="error-message text-xs text-left text-red-500"
                    v-for="(error, index) in localErrors"
                    :key="'error-' + index"
                >
                    {{ error.message }}
                </li>
            </ul>
        </div>
    </transition>
</template>

<script>
import Icon from '@/components/ui/icon/icon.vue';
export default {
    props: {
        errors: Array,
    },
    components: {
        Icon,
    },
    data: () => ({
        dataErrors: [],
    }),
    computed: {
        localErrors: {
            get() {
                return this.errors;
            },
            set(val) {
                this.dataErrors = val;
            },
        },
    },
    methods: {},
};
</script>
